import { PayloadAction } from '@reduxjs/toolkit';
import { User } from 'store/accounts/type';
import {
  BranchNew,
  BranchResults,
  Comments,
  Community,
  CommunityResults,
  LocalStitchCommunity,
  UserPostResults,
} from './type';
import { CommunityState } from './state';

const reducers = {
  getCommunityList(
    state: CommunityState,
    action: PayloadAction<CommunityResults>,
  ): CommunityState {
    state.communityList = action.payload;
    return state;
  },
  getPost(
    state: CommunityState,
    action: PayloadAction<Community>,
  ): CommunityState {
    state.post = action.payload;
    return state;
  },
  getPostComments(
    state: CommunityState,
    action: PayloadAction<Comments[]>,
  ): CommunityState {
    state.comments = action.payload;
    return state;
  },
  getNotices(
    state: CommunityState,
    action: PayloadAction<LocalStitchCommunity>,
  ): CommunityState {
    state.notices = action.payload;
    return state;
  },
  getNoticesFixed(
    state: CommunityState,
    action: PayloadAction<LocalStitchCommunity>,
  ): CommunityState {
    state.noticesFixed = action.payload;
    return state;
  },
  getEvent(
    state: CommunityState,
    action: PayloadAction<Community>,
  ): CommunityState {
    state.event = action.payload;
    return state;
  },
  getNotice(
    state: CommunityState,
    action: PayloadAction<Community>,
  ): CommunityState {
    state.notice = action.payload;
    return state;
  },
  getEvents(
    state: CommunityState,
    action: PayloadAction<LocalStitchCommunity>,
  ): CommunityState {
    state.events = action.payload;
    return state;
  },
  setBranchNews(
    state: CommunityState,
    action: PayloadAction<BranchResults>,
  ): CommunityState {
    state.branch_news = action.payload;
    return state;
  },
  setCommunitySelectUser(
    state: CommunityState,
    action: PayloadAction<User>,
  ): CommunityState {
    state.community_select_user = action.payload;
    return state;
  },
  setUserPostList(
    state: CommunityState,
    action: PayloadAction<UserPostResults>,
  ): CommunityState {
    state.userPostList = action.payload;
    return state;
  },
  setBranchEvent(
    state: CommunityState,
    action: PayloadAction<BranchNew>,
  ): CommunityState {
    state.branch_event = action.payload;
    return state;
  },
  setBranchPost(
    state: CommunityState,
    action: PayloadAction<BranchNew>,
  ): CommunityState {
    state.branch_post = action.payload;
    return state;
  },
};

export default reducers;
